import { render, staticRenderFns } from "./TradingProductFormModal.vue?vue&type=template&id=b9da75ca"
import script from "./TradingProductFormModal.ts?vue&type=script&lang=ts&external"
export * from "./TradingProductFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9da75ca')) {
      api.createRecord('b9da75ca', component.options)
    } else {
      api.reload('b9da75ca', component.options)
    }
    module.hot.accept("./TradingProductFormModal.vue?vue&type=template&id=b9da75ca", function () {
      api.rerender('b9da75ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/TradingProductFormModal.vue"
export default component.exports